import Stage2Player5Room from "../shared/Stage2Player5Room";

export default function Six_Players_Stage2_Player5(props) {
  return <Stage2Player5Room {...props} playerCount={6} />;
}